import React, { useMemo, useState } from 'react';
import { propertyCardProps } from '@src/interfaces/components/propertyCard';
import { formatCurrency, splitAddress } from '@src/v3/utils/helper';
import Image from '@src/v3/components/coreUI/image';
import { ZEME_USERS_ROLE } from '@src/v3/constants/configs';
import Icon from '../coreUI/icon';
import Chip from '../coreUI/chip';
import Link from 'next/link';
import PropertyCardPills from './propertyCardPills';
import { APP_BASE_URL } from '@src/v3/constants/urls';

const PropertyCard: React.FC<propertyCardProps> = (props) => {
  const {
    id,
    role,
    image,
    price,
    address: addressObj,
    bath,
    bedroom,
    squareFootage,
    isMyListing = false,
    isSaved = false,
    handleSaveUnsaveProperty = () => {
      return;
    },
    isExclusive,
    netEffectiveRent,
    leaseConcession,
    leaseMonthsFree,
    // brokerFee,
  } = props;

  //state
  const [saved, setSaved] = useState<boolean>(false);
  const address = useMemo(() => {
    if (addressObj) return splitAddress(addressObj, isExclusive === false);

    return {
      title: '',
      subTitle: '',
    };
  }, [addressObj, isExclusive]);

  useMemo(() => {
    setSaved(isSaved);
  }, [isSaved]);
  const openPropertyUrl = `${APP_BASE_URL}/property/${id}`;
  return (
    <div className="relative mx-auto w-full rounded-lg ">
      <Link href={`${openPropertyUrl}`} target="_blank">
        <div className="relative inline-block w-full transform transition-transform duration-300 ease-in-out cursor-pointer h-full">
          <div className="rounded-lg h-full flex flex-col">
            <div className="relative flex justify-center overflow-hidden rounded-xl">
              <div className="w-full max-h-[200px] min-h-[200px]">
                <Image
                  src={image !== '' ? image : '/no-image.png'}
                  width="500"
                  height="500"
                  alt="thumbnail title"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              {/* Property Details Pill */}
              <div className="absolute top-3 left-3 ">
                <PropertyCardPills
                  bath={bath}
                  bedroom={bedroom}
                  squareFootage={squareFootage}
                />
              </div>
              {role !== ZEME_USERS_ROLE.AGENT &&
              role !== ZEME_USERS_ROLE.LANDLORD ? (
                <span
                  onClick={(
                    event:
                      | React.MouseEvent<HTMLSpanElement, MouseEvent>
                      | undefined
                  ) => {
                    if (!event) return;

                    event.preventDefault();
                    event.stopPropagation();
                    setSaved(!saved);
                    handleSaveUnsaveProperty(id, isSaved);
                  }}
                  className={`${
                    saved && `text-pink-dark`
                  } absolute right-4 top-5 z-10 select-none `}
                >
                  {saved ? (
                    <Icon
                      iconName="heartfill"
                      iconProps={{ className: 'h-6 w-6 text-[#EA3E83]' }}
                    />
                  ) : (
                    <Icon
                      iconName="heartnotfill"
                      iconProps={{
                        className:
                          'h-6 w-6 text-black-dark hover:text-pink-dark',
                      }}
                    />
                  )}
                </span>
              ) : null}
              <div className="absolute flex flex-col bottom-4 left-4 space-y-2 text-sm font-medium tracking-[-0.42px]">
                {/* {brokerFee === 0 ? (
                  <Chip
                    variant="primaryLight"
                    extraClasses="max-w-max !text-sm px-2.5 py-1.5 rounded-lg"
                  >
                    No Fee
                  </Chip>
                ) : null} */}
                {leaseConcession ? (
                  <Chip
                    variant="primary"
                    extraClasses="bg-primary-light !text-sm  text-white px-2.5 py-1.5 rounded-lg"
                  >
                    {parseFloat(String(leaseMonthsFree))}{' '}
                    {`Month${
                      parseFloat(String(leaseMonthsFree)) === 1 ? '' : 's'
                    } Free`}
                  </Chip>
                ) : null}
              </div>
            </div>

            {/* Price Section */}
            <div className="mt-3 flex items-center space-x-2">
              <span className="sm:text-xl/[24px] text-2xl/[28px] font-semibold text-black-dark">
                {formatCurrency(price || 0)}/m
              </span>
              {netEffectiveRent && netEffectiveRent !== price ? (
                <span className="text-sm text-black-dark/50 font-medium">
                  {formatCurrency(netEffectiveRent)}/m Net Rent
                </span>
              ) : null}
            </div>

            <div className="mt-2 flex items-center">
              <div className="relative w-full">
                <h2 className="sm:text-sm/[16px] text-base/[20px] font-medium text-black-dark">
                  {address?.title}
                </h2>
                <div className="flex items-center justify-between">
                  <p className="mt-1 line-clamp-1 sm:text-xs text-base/[20px] text-black-dark/50 font-normal">
                    {address?.subTitle}
                  </p>
                  {isMyListing && (
                    <p className="text-xs text-primary-dark font-medium bg-primary-dark/10 rounded-lg py-1 px-2">
                      My Listing
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default PropertyCard;
